import { fmtTL } from "../../lib/format";

// Şube özeti: yönetici/koordinatör tüm (kapsamındaki) şubeler; şube/GM yetkilisi ve taşeron yalnız kendi kapsamı (onay bekleyen / onaylı / tutar)
export default function BranchSummary({ locations, view }) {
  if (!locations) return null;
  const wide = view === "admin" || view === "scoped";
  const amountLabel = view === "subcontractor" ? "Hakediş Toplamı" : wide ? "Müşteri Toplamı" : "Hizmet Toplamı";
  const amount = (l) => (view === "subcontractor" ? l.subcontractor : l.customer);
  const heads = ["Şube", "Proje", "Kayıt", "Onay Bekleyen", "Onaylı", amountLabel, ...(wide ? ["Taşeron Toplamı", "Brüt Kâr"] : [])];
  return (
    <div className="bg-white border border-slate-200 rounded-lg overflow-hidden" data-testid="dashboard-branches">
      <div className="px-5 py-4 border-b border-slate-100">
        <div className="text-sm font-semibold text-slate-900">Şube Bazlı Özet</div>
        <div className="text-xs text-slate-500">{view === "admin" ? "Aktif kaydı olan tüm şubeler — onay bekleyenler üstte." : "Yalnız yetkili olduğunuz şubelerin aktif kayıtları."}</div>
      </div>
      {locations.length === 0 ? (
        <div className="p-10 text-center text-sm text-slate-500" data-testid="dashboard-branches-empty">{view === "admin" ? "Henüz aktif kayıt yok." : "Şubelerinizde henüz kayıt yok."}</div>
      ) : (
        <div className="overflow-x-auto">
          <table className="w-full tbl min-w-[560px]">
            <thead className="bg-slate-50"><tr>
              {heads.map((h, i) => <th key={h} className={`px-4 py-2.5 text-xs uppercase tracking-wider text-slate-600 font-semibold ${i >= 2 ? "text-right" : "text-left"}`}>{h}</th>)}
            </tr></thead>
            <tbody>
              {locations.map((l) => (
                <tr key={l.location_id} className="border-t border-slate-100" data-testid={`dashboard-branch-${l.location_id}`}>
                  <td className="px-4 py-2.5 text-sm font-medium text-slate-900">{l.location_name}</td>
                  <td className="px-4 py-2.5 text-xs text-slate-600">{l.project_name}</td>
                  <td className="numeric-cell px-4 py-2.5 text-sm">{l.entries}</td>
                  <td className="numeric-cell px-4 py-2.5 text-sm">{l.pending > 0 ? <span className="px-1.5 py-0.5 rounded bg-amber-100 text-amber-800 font-bold text-xs">{l.pending}</span> : <span className="text-slate-400">0</span>}</td>
                  <td className="numeric-cell px-4 py-2.5 text-sm text-emerald-700 font-semibold">{l.approved}</td>
                  <td className="numeric-cell px-4 py-2.5 text-sm">{fmtTL(amount(l))}</td>
                  {wide && <td className="numeric-cell px-4 py-2.5 text-sm">{fmtTL(l.subcontractor)}</td>}
                  {wide && <td className="numeric-cell px-4 py-2.5 text-sm font-semibold text-emerald-700">{fmtTL(l.gross_profit)}</td>}
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      )}
    </div>
  );
}
